import { Fragment, useContext } from 'react';
import { useFormikContext } from 'formik';

import { PageContext } from '../../../contexts/PageContext';
import { CategoriesSelect } from '../../Form/CategoriesSelect/CategoriesSelect';
import { UsePageTaxonomyCheckbox } from '../DataSource/EndpointParamsPicker/EndpointParamsForm/UsePageTaxonomyCheckbox/UsePageTaxonomyCheckbox';
import { FiltersPicker } from '../../FiltersPicker/FiltersPicker';
import { Input } from '../../Form/Input/Input';

import type { ComponentResponse } from '../../../types';
import type { Filter } from '../../FiltersPicker/types';

type Props = {
  isStandalone?: boolean;
};

function FilteredListFields({ isStandalone }: Props) {
  const { values: component, setFieldValue } =
    useFormikContext<ComponentResponse>();
  const { page } = useContext(PageContext);

  const showCheckbox =
    isStandalone ||
    page.type === 'category' ||
    (page.type === 'template' && page.forType === 'category');

  const usePageTaxonomy = component?.options?.usePageTaxonomy ?? true;

  return (
    <Fragment>
      <CategoriesSelect
        label="Search within category"
        name="categoryId"
        disabled={usePageTaxonomy}
      />
      {showCheckbox && (
        <UsePageTaxonomyCheckbox
          setFieldValue={setFieldValue}
          taxonomy="category"
          checked={usePageTaxonomy}
        />
      )}
      <FiltersPicker
        filters={component.filters as Filter[] | undefined}
        onChange={(filters) => {
          setFieldValue('filters', filters);
        }}
      />
      <Input label="Search field placeholder" name="options.placeholder" />
    </Fragment>
  );
}

export { FilteredListFields };
